import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "homework-page"
}
const _hoisted_2 = { class: "weekdays-list" }
const _hoisted_3 = { class: "homework-list" }

import { onMounted, reactive } from 'vue';
import { GetHomeworkPageResponseModel } from './HomeworkPage.types';
import { getHomeworkPage } from './apiMethods';
import ExpansionPanel from '@/common/components/snedson-material-components/expansion-panel/expansion-panel.vue';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeworkPage',
  setup(__props) {

const state = reactive<{ data: GetHomeworkPageResponseModel | null }>({
    data: null,
});

onMounted(() => {
    getHomeworkPage().then((res) => {
        state.data = res.data;
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(state.data.homework), (day, dayIndex) => {
            return (_openBlock(), _createBlock(ExpansionPanel, {
              key: dayIndex,
              props: { title: new Date(day[0]).toLocaleDateString() }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day[1], (homework, homeworkIndex) => {
                    return (_openBlock(), _createBlock(UniversalCard, {
                      class: _normalizeClass(homework.colorSchemeName),
                      props: {
                            type: 'filled',
                            content: homework.taskText,
                            dataTags: [
                                {
                                    color: 'var(--snotra--sys--surface)',
                                    title: homework.subjectName,
                                    iconCompleteUrl:
                                        _unref(getBaseUrl)() + homework.iconURL,
                                },
                                {
                                    color: 'var(--snotra--sys--surface)',
                                    title: homework.groupName
                                        ? homework.groupName
                                        : 'Весь класс',
                                    iconLocal: 'student.png',
                                },
                                {
                                    color: 'var(--snotra--sys--surface)',
                                    title: `Задание добавлено: ${new Date(
                                        homework.appendDate
                                    ).toLocaleDateString()}`,
                                    iconLocal: 'calendar.png',
                                },
                                {
                                    color: 'var(--snotra--sys--surface)',
                                    title: `Задание добавил: ${homework.authorName}`,
                                    iconLocal: 'student.png',
                                },
                            ],
                        },
                      key: homeworkIndex
                    }, null, 8, ["class", "props"]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["props"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})